/* eslint-disable array-callback-return */
import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import ApiCalls from "../../apis/api-calls";
import ChangePassword from "../../Authentication/ChangePassword/ChangePassword";
import Utility from "../../../common/utility";
import "../../../assets/css/style.css";
import "../../../assets/css/components/Profile/ProfileForm/ProfileForm.css";
import SuccessModal from "../../common/SuccessModal/SuccessModal";
import ErrorModal from "../../common/ErrorModal/ErrorModal";

const ProfileForm = inject("sharedStore", "profileStore")(observer(class ProfileForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstname: "",
      isValidFirstName: true,
      firstNameErrorMsg: "",
      lastname: "",
      isValidLastName: true,
      lastNameErrorMsg: "",
      company: "",
      email: "",
      isValidEmail: true,
      emailErrorMsg: "",
      password: "",
      country: "",
      state: "",
      city: "",
      countryList: [],
      stateList: [],
      cityList: [],
      isEditable: false,
      check: false,
      role: "",
      dataOffset: 0,
      timestampOffset: 0,
      timeZone: "",
      timeZoneText: "",
      language: "1",
      dateFormat: "MM/DD/YYYY",
      dateFormatList: ["MM/DD/YYYY", "DD/MM/YYYY", "YYYY/MM/DD"],
      visibleModal: "",
    };
    this.handleChange = this.handleChange.bind(this);
    //this.switchModalVisibility = this.switchModalVisibility.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    var timeZone, timeZoneText, timestampOffset;
    let stateData = { ...prevState };
    let memberData =
      (nextProps.sharedStore &&
        nextProps.sharedStore.membersData &&
        nextProps.sharedStore.membersData.slice()) ||
      [];
    let timezoneData =
      (nextProps.sharedStore &&
        nextProps.sharedStore.timezoneData &&
        nextProps.sharedStore.timezoneData.slice()) ||
      [];
    if (stateData.timeZoneText === undefined || stateData.timeZoneText === "") {
      const userId = Utility.getData("userId");
      memberData.map((member, i) => {
        if (member.userId === userId) {
          timezoneData.map((tz, i) => {
            if (member.timezone === tz.id) {
              timeZone = member.timezone;
              timeZoneText = tz.text;
              timestampOffset = tz.offset;
            }
          });
        }
      });
      stateData = {
        ...stateData,
        timeZone,
        timeZoneText,
        timestampOffset,
      };
    }
    return { ...stateData };
  }

  componentDidMount() {
    this.getProfileDetail();
    this.fetchTimeZoneData();
    ApiCalls.getcountry()
      .then((json) => {})
      .catch((err) => console.log("err", err));
  }

  closeModal() {
    this.setState({
      visibleModal: "",
    });
  }

  switchModalVisibility = (e, modalId, data = {}) => {
    switch (modalId) {
      case 0:
        this.setState({
          visibleModal: modalId,
        });
        break;
      case 1:
        this.setState({
          visibleModal: modalId,
          modalResponseMessage: data.successMessage,
        });
        break;
      case 2:
        this.setState({
          visibleModal: modalId,
          modalResponseMessage: data.errorMessage,
        });
        break;
      default:
    }
  };

  fetchTimeZoneData = () => {
    this.props.sharedStore.showLoader();
    ApiCalls.fetchTimeZoneInfo().then((response) => {
      this.props.sharedStore.hideLoader();
      this.props.sharedStore.setTimeZoneData(response.data);
    });
  };

  getProfileDetail() {
    this.props.sharedStore.showLoader();
    ApiCalls.getProfile().then((resp) => {
      this.props.sharedStore.hideLoader();
      if (resp && resp.error === false) {
        let json = resp.data;
        this.props.sharedStore.setCustomerSeriesType(json.customer_series);
        // this.props.store.email = json["email"] || "";
        this.props.sharedStore.setProfileData(json);
        this.setState(
          {
            firstname: json["first_name"] || "",
            lastname: json["last_name"] || "",
            role: json["role"] || "",
            // fullname: json['full_name'] || '',
            email: json["email"] || "",
            company: json["company"] || "",
            country: json["country"] || "",
            state: json["state"] || "",
            city: json["city"] || "",
          },
          () => {
            if (this.state.country !== "") {
              this.getState(this.state.country);
              // ApiCalls.getState(this.state.country);
            }
            if (this.state.state !== "") {
              this.getCity(this.state.state);
            }
            this.props.sharedStore.username =
              this.state.firstname + " " + this.state.lastname;
          }
        );
      }
    });
  }

  getState(country) {
    ApiCalls.getState(country).then((json) => {
      if (json.error === false) {
        this.setState({ stateList: json.data });
      }
    });
  }

  getCity(state) {
    ApiCalls.getCity(state).then((json) => {
      if (json.error === false) {
        this.setState({ cityList: json.data });
      }
    });
  }

  handleChange(e) {
    let change = {};
    change[e.target.name] = e.target.value;
    this.setState(change);
    if (e.target.name === "email") {
      let { isValidEmail, emailErrorMsg } = this.state;
      isValidEmail = true;
      emailErrorMsg = "";
      this.setState({ isValidEmail, emailErrorMsg });
    } else if (e.target.name === "firstname") {
      let { isValidFirstName, firstNameErrorMsg } = this.state;
      isValidFirstName = true;
      firstNameErrorMsg = "";
      this.setState({ isValidFirstName, firstNameErrorMsg });
    } else if (e.target.name === "lastname") {
      let { isValidLastName, lastNameErrorMsg } = this.state;
      isValidLastName = true;
      lastNameErrorMsg = "";
      this.setState({ isValidLastName, lastNameErrorMsg });
    }
  }

  handleCountryChange(e) {
    let change = {};
    change[e.target.name] = e.target.value;
    change.cityList = ["Select City"];
    this.getState(e.target.value);
    this.setState(change);
  }

  handleStateChange(e) {
    let change = {};
    change[e.target.name] = e.target.value;
    this.setState(change);
    this.getCity(e.target.value);
  }

  handleCityChange(e) {
    let change = {};
    change[e.target.name] = e.target.value;
    this.setState(change);
  }

  handleEdit = (event) => {
    event.preventDefault();
    const userData = this.props.sharedStore.profileData;
    this.setState(
      {
        firstname: userData.first_name,
        isValidFirstName: true,
        firstNameErrorMsg: "",
        lastname: userData.last_name,
        isValidLastName: true,
        lastNameErrorMsg: "",
        role: userData.role,
        email: userData.email,
        isValidEmail: true,
        emailErrorMsg: "",
        company: userData.company,
        country: userData.country,
        state: userData.state,
        city: userData.city,
        isEditable: !this.state.isEditable,
      },
      () => {
        if (this.state.country !== "") {
          this.getState(this.state.country);
        }
        if (this.state.state !== "") {
          this.getCity(this.state.state);
        }
      }
    );
    this.setState({
      check: true,
    });
  };

  checkValidation = () => {
    let {
      firstname,
      lastname,
      email,
      isValidEmail,
      emailErrorMsg,
      isValidFirstName,
      isValidLastName,
      firstNameErrorMsg,
      lastNameErrorMsg,
    } = this.state;
    if (email !== "") {
      let testEmail = Utility.isValidEmail(email);
      if (testEmail) {
        isValidEmail = true;
        emailErrorMsg = "";
      } else {
        isValidEmail = false;
        emailErrorMsg = "Email address is invalid";
      }
    } else {
      isValidEmail = false;
      emailErrorMsg = "Email address cannot be left blank";
    }
    this.setState({ isValidEmail, emailErrorMsg });

    if (firstname !== "") {
      let testFirstName = Utility.isValidName(firstname);
      if (!testFirstName) {
        isValidFirstName = false;
        firstNameErrorMsg = "Name is invalid";
      }
    } else {
      isValidFirstName = false;
      firstNameErrorMsg = "Name cannot be left blank";
    }
    if (lastname !== "") {
      let testLastName = Utility.isValidName(lastname);
      if (!testLastName) {
        isValidLastName = false;
        lastNameErrorMsg = "Name is invalid";
      }
    } else {
      isValidLastName = false;
      lastNameErrorMsg = "Name cannot be left blank";
    }
    this.setState({
      isValidFirstName,
      isValidLastName,
      firstNameErrorMsg,
      lastNameErrorMsg,
    });
    return isValidFirstName && isValidLastName && isValidEmail;
  };

  handleSubmit = (e) => {
    if (this.checkValidation()) {
      this.props.sharedStore.showLoader();
      let data = {
        first_name: this.state.firstname || "",
        last_name: this.state.lastname || "",
        company: this.state.company || "",
        country: this.state.country || "",
        state: this.state.state || "",
        city: this.state.city || "",
        email: this.state.email || "",
        timezone: parseInt(this.state.timeZone, 10) || "",
        language: parseInt(this.state.language, 10) || "",
      };
      let userProfileData = {
        first_name: this.state.firstname || "",
        last_name: this.state.lastname || "",
        company: this.state.company || "",
        country: this.state.country || "",
        state: this.state.state || "",
        city: this.state.city || "",
        email: this.state.email || "",
        role: this.state.role || "",
      };
      let emailObj = {
        email: this.state.email,
        userId: Utility.getData("userId"),
      };
      let { isValidEmail, emailErrorMsg } = this.state;
      ApiCalls.isExistingMember(emailObj).then((response) => {
        this.props.sharedStore.hideLoader();
        if (response && response.error === true) {
          isValidEmail = false;
          emailErrorMsg = "Email address is already in use";
          this.setState({ isValidEmail, emailErrorMsg });
        } else if (response && response.error === false) {
          fetch("api/user/profile/", {
            method: "put",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
          }).then((json) => {
            this.props.sharedStore.hideLoader();
            if (json.error === false) {
              let data = {
                successMessage: json.message,
              };
              this.switchModalVisibility(null, 1, data);
              this.props.sharedStore.setProfileData(userProfileData);
              this.props.sharedStore.username =
                this.state.firstname + " " + this.state.lastname;
              // document.getElementById('displayUser').innerHTML = nameReplace
              // document.getElementById('displayAngleDown').innerHTML = "<i className='fa fa-angle-down' style='color:white; opacity:0.75; margin-left: 22px; margin-top: 4.5px;'></i>"
            } else {
              let data = {
                errorMessage: json.message,
              };
              this.getProfileDetail();
              this.switchModalVisibility(null, 2, data);
            }
          });
          this.setState({
            isEditable: false,
          });
        }
      });
    }
  };

  handleDateFormatChange = (e) => {
    let { dateFormat } = this.state;
    dateFormat = e.target.value;
    this.setState({ dateFormat });
  };

  renderTimezoneList = () => {
    let { timeZone } = this.state;
    const timezoneList =
      this.props.sharedStore.timezoneData.length > 0
        ? this.props.sharedStore.timezoneData.slice()
        : [];
    const options = timezoneList.map((obj, index) => (
      <option
        value={obj.id}
        key={index}
        selected={obj.id === timeZone ? true : false}
      >
        {obj.text}
      </option>
    ));
    return options;
  };

  changeTimeZone = (e) => {
    let { timeZone, timestampOffset, timeZoneText } = this.state;
    const timezoneData = this.props.sharedStore.timezoneData;
    timeZone = e.target.value;
    timeZoneText = e.target.options[e.target.selectedIndex].text;
    timezoneData.map(function (tz, i) {
      if (timeZone === tz.id) {
        timestampOffset = tz.offset;
      }
    });
    this.setState({
      timeZone,
      timestampOffset,
      timeZoneText,
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.sharedStore &&
      prevProps.sharedStore.profileData &&
      prevProps.sharedStore.profileData.first_name !== prevState.firstname &&
      !prevState.check
    ) {
      this.setState({
        firstname: prevProps.sharedStore.profileData.first_name,
        lastname: prevProps.sharedStore.profileData.last_name,
      });
    }
  }

  render() {
    const {
      isValidEmail,
      emailErrorMsg,
      isValidFirstName,
      isValidLastName,
      firstNameErrorMsg,
      lastNameErrorMsg,
    } = this.state;
    document.body.removeAttribute("class");
    return (
      <div>
        <SuccessModal
          modalVisibility={this.state.visibleModal === 1 ? true : false}
          closeModalHandler={this.closeModal}
          messageContent={this.state.modalResponseMessage}
          modalLabel="Success Modal"
          doneBtnId="doneButtonProfile"
          modalClass="iz-modal"
        />

        <ErrorModal
          modalVisibility={this.state.visibleModal === 2 ? true : false}
          closeModalHandler={this.closeModal}
          messageContent={this.state.modalResponseMessage}
          modalLabel="Error Modal"
          modalClass="iz-modal"
        />

        <form>
          {/* <div className="" >
                    <span> <img src={require('../../../assets/images/profile.jpeg')} className="profImage" /></span>
                </div> */}
          <div className="wrap-block">
            <div className="row">
              <div className="col-xs-12 col-md-12 col-lg-8">
                <div className="row">
                  <div className="col-md-6 profile-input-col">
                    <div className="d-flex field-group">
                      <div className="flex-40">
                        <label htmlFor="firstName">First Name</label>
                      </div>
                      {this.state.isEditable ? (
                        <div
                          className={
                            isValidFirstName
                              ? "input-flex"
                              : "input-flex flex-wrap error-wrapper"
                          }
                        >
                          <input
                            type="text"
                            maxLength="29"
                            name="firstname"
                            className="form-control"
                            id="firstName"
                            value={this.state.firstname}
                            onChange={this.handleChange}
                          />
                          {!isValidFirstName ? (
                            <div className={"text-error"}>
                              {firstNameErrorMsg}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        <div className="input-flex">
                          <span className="view-text">
                            {this.state.firstname}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="d-flex field-group">
                      <div className="flex-40">
                        <label htmlFor="lastName">Last Name</label>
                      </div>
                      {this.state.isEditable ? (
                        <div
                          className={
                            isValidLastName
                              ? "input-flex"
                              : "input-flex flex-wrap error-wrapper"
                          }
                        >
                          <input
                            type="text"
                            maxLength="29"
                            name="lastname"
                            value={this.state.lastname}
                            onChange={this.handleChange}
                            className="form-control"
                            id="lastName"
                          />
                          {!isValidLastName ? (
                            <div className={"text-error"}>
                              {lastNameErrorMsg}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        <div className="input-flex">
                          <span className="view-text">
                            {this.state.lastname}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="d-flex field-group">
                      <div className="flex-40">
                        <label htmlFor="email">Email *</label>
                      </div>
                      {this.state.isEditable ? (
                        <div
                          className={
                            isValidEmail
                              ? "input-flex"
                              : "input-flex flex-wrap error-wrapper"
                          }
                        >
                          <input
                            type="email"
                            name="email"
                            value={this.state.email}
                            onChange={this.handleChange}
                            className="form-control"
                            // id="email"
                            placeholder="you@example.com"
                          />
                          {!isValidEmail ? (
                            <div className={"text-error"}>{emailErrorMsg}</div>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        <div className="input-flex">
                          <span className="view-text">{this.state.email}</span>
                        </div>
                      )}
                    </div>

                    <div className="d-flex field-group">
                      <div className="flex-40">
                        <label htmlFor="company_name">Company Name</label>
                      </div>
                      {this.state.isEditable ? (
                        <div className="input-flex">
                          <input
                            type="text"
                            name="company"
                            value={this.state.company}
                            readOnly={true}
                            className="form-control bg-grey"
                            id="company_name"
                            placeholder="company name"
                            required
                          />
                        </div>
                      ) : (
                        <div className="input-flex">
                          <span className="view-text">
                            {this.state.company}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="d-flex field-group">
                      <div className="flex-40">
                        <label htmlFor="Country">Country</label>
                      </div>
                      {this.state.isEditable ? (
                        <div className="input-flex">
                          <select
                            className="form-control"
                            name="country"
                            value={this.state.country}
                            onChange={this.handleCountryChange.bind(this)}
                            placeholder="select"
                          >
                            {this.state.countryList.map((country, i) => {
                              return (
                                <option key={i} value={country.name}>
                                  {country.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      ) : (
                        <div className="input-flex">
                          <span className="view-text">
                            {this.state.country}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="d-flex field-group">
                      <div className="flex-40">
                        <label htmlFor="state">State</label>
                      </div>
                      {this.state.isEditable ? (
                        <div className="input-flex">
                          <select
                            className="form-control"
                            name="state"
                            value={this.state.state}
                            onChange={this.handleStateChange.bind(this)}
                            placeholder="select"
                          >
                            {this.state.stateList.map((state, i) => {
                              return (
                                <option key={i} value={state.name}>
                                  {state.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      ) : (
                        <div className="input-flex">
                          <span className="view-text">{this.state.state}</span>
                        </div>
                      )}
                    </div>
                    <div className="d-flex field-group">
                      <div className="flex-40">
                        <label htmlFor="city">City</label>
                      </div>
                      {this.state.isEditable ? (
                        <div className="input-flex">
                          <select
                            className="form-control"
                            name="city"
                            value={this.state.city}
                            onChange={this.handleCityChange.bind(this)}
                            placeholder="select"
                          >
                            {this.state.cityList.map((city, i) => {
                              return (
                                <option key={i} value={city.name}>
                                  {city.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      ) : (
                        <div className="input-flex">
                          <span className="view-text">{this.state.city}</span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6 profile-input-col">
                    <div className="d-flex field-group">
                      <div className="flex-40">
                        <label htmlFor="lastName">Time Zone</label>
                      </div>
                      <div className="input-flex">
                        {this.state.isEditable ? (
                          <select
                            className="form-control"
                            name="timezone"
                            onChange={(e) => this.changeTimeZone(e)}
                          >
                            {this.renderTimezoneList()}
                          </select>
                        ) : (
                          <span className="view-text">
                            {this.state.timeZoneText}
                          </span>
                        )}
                        {/* <input type="text"
                                            maxLength="29"
                                            name="dataOffset"
                                            className="form-control"
                                            id="timezone"
                                            value={this.state.dataOffset}
                                            onChange={this.handleChange.bind(this)}
                                            required
                                        /> */}
                      </div>
                    </div>

                    <div className="d-flex field-group">
                      <div className="flex-40">
                        <label htmlFor="state">Language</label>
                      </div>
                      <div className="input-flex">
                        {this.state.isEditable ? (
                          <select
                            className="form-control"
                            name="language"
                            onChange={this.handleChange}
                          >
                            <option>English - United States</option>
                          </select>
                        ) : (
                          <span className="view-text">
                            English - United States
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="d-flex field-group">
                      <div className="flex-40">
                        <label htmlFor="state">Date</label>
                      </div>
                      <div className="input-flex">
                        {this.state.isEditable ? (
                          <select
                            className="form-control"
                            name="dateformat"
                            value={this.state.dateFormat}
                            onChange={(e) => this.handleDateFormatChange(e)}
                            placeholder="select"
                          >
                            {this.state.dateFormatList.map((dateFormat, i) => {
                              return (
                                <option key={i} value={dateFormat}>
                                  {dateFormat}
                                </option>
                              );
                            })}
                          </select>
                        ) : (
                          <span className="view-text">
                            {this.state.dateFormat}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-12 col-md-12">
                    <div className="profile-btn-wrapper">
                      {this.state.isEditable ? (
                        <React.Fragment>
                          <button
                            className="btn btn-common-secondary btn-profile-lg mr-10"
                            onClick={(e) => this.handleEdit(e)}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btn btn-common btn-profile-lg"
                            onClick={(e) => this.handleSubmit(e)}
                          >
                            Save Changes
                          </button>
                        </React.Fragment>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-common btn-profile-lg"
                          onClick={(e) => this.handleEdit(e)}
                        >
                          Edit
                        </button>
                      )}
                    </div>
                    {/* <div className="flexProfileItem" id="profileBottomText">*required fields</div> */}
                  </div>
                </div>
              </div>
              <div className="col-xs-12  col-md-4 col-lg-4 profile-input-col">
                {/* Change Password */}
                <ChangePassword
                  modalVisibility={this.state.visibleModal === 0 ? true : false}
                  closeModalHandler={this.closeModal}
                  forgotEmail={this.state.forgotEmail}
                  switchModalVisibility={this.switchModalVisibility}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}));

export default ProfileForm;



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileForm/ProfileForm.jsx